<div class="market-shares-wrapper">
    @if (marketSalesDataService.estateSaleIsLoading()) {
        <div style="padding: 20px; display: flex; justify-content: center">
            <ev-logo-loader width="70px" />
        </div>
    } @else {
        @if (filterForm().value()) {
            <div
                class="section-wrapper is-header"
                [class.no-margin]="filterForm().value().searchViewOptions.periodDefinitionType === periodType.Sold"
                [class.in-market]="filterForm().value().searchViewOptions.periodDefinitionType === periodType.InMarket"
            >
                <div class="centered-row-wrapper">
                    <div class="period-header">
                        <div class="date">{{ computedTimePeriod().fromDate | date: "shortDate" }}</div>
                        <div class="left-arrow"></div>
                        <div
                            class="period-type-icon"
                            [class.registered-icon]="filterForm().value().searchViewOptions.periodDefinitionType === periodType.Registered"
                            [class.sold-icon]="filterForm().value().searchViewOptions.periodDefinitionType === periodType.Sold"
                            [class.inmarket-icon]="filterForm().value().searchViewOptions.periodDefinitionType === periodType.InMarket"
                        ></div>
                        <div class="right-arrow"></div>
                        <div class="date">{{ computedTimePeriod().toDate | date: "shortDate" }}</div>
                    </div>
                </div>
                <div class="flex-col" [class.count-separator]="filterForm().value().searchViewOptions.periodDefinitionType !== periodType.InMarket">
                    <div class="uppercase-text primary-color">Meglersalg</div>
                    <div class="uppercase-text secondary-color">i perioden</div>
                    <div class="extra-big-number">{{ estateAgentMarketShareView().total | thousandize }}</div>
                </div>
            </div>
        }
        <div class="table-wrapper">
            <div class="container">
                <table class="tbl">
                    <thead>
                        <tr>
                            <th class="t-header name">Megler</th>
                            <th class="t-header values">
                                <div class="th-navigation-container">
                                    <div class="headers">
                                        <div class="percent" [class.active]="!showSale" (click)="showSale = false">%</div>
                                        <div class="num" [class.active]="showSale" (click)="showSale = true">Antall</div>
                                    </div>
                                    <div class="arrow-container" [class.sale-pos]="showSale">
                                        <div class="arrow"></div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of estateAgentMarketShareView().details; track item; let i = $index) {
                            <tr class="t-rows">
                                <td class="td name"><span class="name-container" [innerHtml]="item.key | safe: 'html'"></span></td>
                                <td class="td values">{{ showSale ? item.value : (item.percent | percent: "1.1-1") }}</td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
</div>
